import React, { useContext, useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";

//import NotificationsIcon from "@mui/icons-material/Notifications";
import {
  Autocomplete,
  Badge,
  Fab,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  createFilterOptions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { getAllDealers } from "../services/dealerServices";
import EmailNotificationBtn from "./EmailNotificationBtn";
import UserProfileMenu from "./UserProfileMenu";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { MdSupportAgent } from "react-icons/md";
import { MdOutlineNewspaper } from "react-icons/md";
import { envConfig } from "../services/configs/envConfig";
import { ContactUsDialog } from "./ContactUsDialog";
import { DealerSearch } from "./DealerSearch";
import { MdPayments } from "react-icons/md";


const TopBar = (props) => {
  const {
    user,
    signOut,
    group,
    //dealer,
    setDealer,
    setIsOnboarded,
    setOnboarding,
    APP_ENV,
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const [accountType, setAccountType] = useState("");
  const [dealerList, setDealerList] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [openContactUs, setOpenContactUs] = useState(false);
  const [contactData, setContactData] = useState(null);
  const location = useLocation();
  const isDealerDetailsPage =
    (group === "jbw-admin" &&
      location.pathname.includes("/home/dealerdetails")) ||
    group === "jbw-dealer";

  const dealer = localStorage.getItem("dealer")
    ? JSON.parse(localStorage.getItem("dealer"))
    : null;

  const handleContactUs = () => setOpenContactUs(true);

  const handleMakeJbPayments = () => {
    window.open(`${envConfig.JBWLegacyUrl}/member/secure/account.aspx?tab=3`, "_blank");
  };

  const filterOptions = createFilterOptions({
    stringify: (option) => option.id + option.dealerName,
  });
  useEffect(() => {
    setAccountType(group !== "jbw-dealer" ? "Admin Account" : "Dealer Account");
  }, [group]);

  useEffect(() => {
    console.log(
      "group :: " + group,
      "dealer :: " + localStorage.getItem("dealer"),
      " LOcation ::" + location.pathname.includes("/home/dealerdetails"),
    );
    setSelectedDealer(dealer);
    setContactData({
      firstName: dealer?.registeredName,
      //lastName: "",
      email: dealer?.registeredEmail,
      phoneNumber: "",
      companyName: dealer?.dealerName,
      dealerId: dealer?.dealerId,
      ctype: "",
      comments: "",
      consent: false,
    });
  }, [dealer?.dealerId]);

  useEffect(() => {
    getAllDealers()
      .then(
        (res) => {
          const data = APP_ENV === "Development" ? res.data.body : res.data;
          console.log("Global Search All Dealers list ", res.data);
          if (data && data.length > 0) {
            setDealerList(data);
          }
        },
        (err) => {
          console.log("Error calling getAllDealers : ", err);
          // setClientErr("Uable to Load Clients");
        },
      )
      .catch((err) => {
        console.log("Internal server error:", err);
        //setClientErr("Internal server error");
      });
  }, []);

  const handleLogOut = () => {
    signOut();
    navigate("/");
  };

  const barwidth = props.isOpen
    ? `calc(100% - ${"200px"})`
    : `calc(100% - ${"60px"})`;

  const handleDownloadReleaseNotes = () => {
    const fileUrl = envConfig.RNUrl;
    const fileName = fileUrl.split("/").pop();
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadTerms = () => {
    const fileUrl = envConfig.TermsUrl;
    const fileName = fileUrl.split("/").pop();
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <AppBar
      position="fixed"
      sx={{
        width: barwidth,
        ml: "300px",
        pl: "30px",
        boxShadow: "0",
        backgroundColor: "#EFEFEF",
        color: "#000",
      }}
    >
      {isDealerDetailsPage && contactData && (
        <ContactUsDialog
          open={openContactUs}
          onClose={() => setOpenContactUs(false)}
          initialValues={contactData}
        />
      )}
      <Toolbar>
        <Box>
          <Typography component="h6">
            {group !== "jbw-dealer"
              ? `Hello ${user?.name}.`
              : `Hello ${dealer?.dealerName}`}
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        {group === "jbw-admin" && (
          // <Autocomplete
          //   freeSolo
          //   id="dealer-search-auto"
          //   //disableClearable
          //   value={selectedDealer}
          //   clearOnBlur={true}
          //   getOptionLabel={(option) =>
          //     `${option.dealerId} - ${option.dealerName}`
          //   }
          //   filterOptions={filterOptions}
          //   options={dealerList}
          //   onChange={(event, value) => {
          //     console.log("dealer auto complete :", value);
          //     if (!value) return;
          //     setDealer(value);
          //     localStorage.setItem("dealer", JSON.stringify(value));
          //     if (value.onboard_status === 1) {
          //       navigate(`/home/dealerdetails`);
          //     } else {
          //       setOnboarding({
          //         dealerId: value.dealerId,
          //         dealerName: value.dealerName,
          //       });

          //       //setNavigationLink("/home/onboarding/clientlocation");
          //       setIsOnboarded(false);
          //       navigate("/home/onboarding/clientlocation", {
          //         state: { key: "onboardinghome" },
          //       });
          //     }
          //   }}
          //   sx={{
          //     width: 450,
          //     borderRadius: "20px",
          //     mr: 20,

          //     ".MuiOutlinedInput-root": {
          //       borderRadius: "20px",
          //       p: "2px",
          //       "&:hover": {
          //         borderRadius: 10,
          //         borderColor: "red",
          //         borderWidth: 10,
          //       },
          //     },
          //     "input[type='search']::-webkit-search-cancel-button": {
          //       display: "none",
          //     },
          //   }}
          //   renderInput={(params) => (
          //     <TextField
          //       sx={{
          //         ".MuiInputBase-root": {
          //           borderRadius: "20px",
          //           borderColor: "#e0e0e0",
          //           ":hover": {
          //             borderColor: "#e0e0e0",
          //           },
          //         },
          //         "& .MuiOutlinedInput-root": {
          //           legend: {
          //             marginLeft: "30px",
          //           },
          //         },
          //         "& .MuiInputLabel-outlined": {
          //           paddingLeft: "35px",
          //         },
          //       }}
          //       {...params}
          //       label=""
          //       placeholder="Search Dealer"
          //       InputProps={{
          //         ...params.InputProps,
          //         type: "search",
          //         startAdornment: (
          //           <InputAdornment position="start">
          //             <SearchIcon style={{ fill: "#ffc400" }} />
          //           </InputAdornment>
          //         ),
          //       }}
          //     />
          //   )}
          // />
          <Box sx={{ position: "relative", marginRight: 35 }}>
            <DealerSearch
              onSelect={(value) => {
                console.log("dealer auto complete :", value);
                if (!value) return;
                setDealer(value);
                localStorage.setItem("dealer", JSON.stringify(value));
                if (value.onboard_status === 1) {
                  navigate(`/home/dealerdetails`);
                } else {
                  setOnboarding({
                    dealerId: value.dealerId,
                    dealerName: value.dealerName,
                  });

                  //setNavigationLink("/home/onboarding/clientlocation");
                  setIsOnboarded(false);
                  navigate("/home/onboarding/clientlocation", {
                    state: { key: "onboardinghome" },
                  });
                }
              }}
            />
          </Box>
        )}

        <Box sx={{ display: { xs: "none", md: "flex" } }}>
                    <Typography
            variant="subtitle2"
            component="div"
            sx={{ marginLeft: "10px", marginRight: "10px" }}
          >
            {user?.name} <br />
            <Typography
              variant="body2"
              component="div"
              sx={{ color: "#a8a8a8d4" }}
            >
              {accountType}
            </Typography>
          </Typography>
          {/* <Tooltip title="Make Payment">
            <Fab
              size="small"
              edge="end"
              aria-label="Click here to navigate to JB Payments Page"
              sx={{ marginRight: "15px" }}
              color="secondary"
              onClick={handleMakeJbPayments}
            >
              <MdPayments fontSize="25px" color="#000" />
            </Fab>
          </Tooltip> */}

          <Tooltip title="Download Release Notes">
            <Fab
              size="small"
              edge="end"
              aria-label="Download Release Notes"
              sx={{ marginRight: "15px" }}
              color="secondary"
              onClick={handleDownloadReleaseNotes}
            >
              <MdOutlineNewspaper fontSize="25px" color="#000"  />
            </Fab>
          </Tooltip>
          <Tooltip title="Download Terms of Use">
            <Fab
              size="small"
              edge="end"
              aria-label="Download Terms of Use"
              sx={{ marginRight: "15px" }}
              color="secondary"
              onClick={handleDownloadTerms}
            >
              <ArticleOutlinedIcon fontSize="small" />
            </Fab>
          </Tooltip>
          {/* <EmailNotificationBtn /> */}
          {isDealerDetailsPage && (
            <Tooltip title="Contact Support">
              <Fab
                size="small"
                edge="end"
                aria-label="Click here for support"
                sx={{ marginRight: "15px" }}
                color="secondary"
                onClick={handleContactUs}
              >
                <MdSupportAgent fontSize="35px" color="#000" />
              </Fab>
            </Tooltip>
          )}

          {/* <IconButton
            size="large"
            aria-label="show 1 new notifications"
            sx={{ color: "#a8a8a8d4", marginLeft: "10px", marginRight: "10px" }}
          >
            <Badge badgeContent={3} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
          {/* <Fab
            size="small"
            edge="end"
            aria-label="account of current user"
            aria-haspopup="true"
            color="secondary"
          >
            <AccountCircle style={{ fill: "white" }} fontSize="small" />
          </Fab> */}

          <UserProfileMenu logOut={handleLogOut} />
          {/* <Fab
            size="small"
            edge="end"
            aria-label="Log Out current user"
            aria-haspopup="true"
            color="secondary"
            onClick={handleLogOut}
          >
            <LogoutIcon fontSize="small" />
          </Fab> */}
        </Box>
      </Toolbar>
      <Box>
        {(APP_ENV === "Staging" || APP_ENV === "Development") && (
          <marquee
            behavior="scroll"
            scrollamount="10"
            width="100%"
            direction="right"
            height="25px"
            style={{
              fontSize: "18px",
              color: "#FF2929",
              fontWeight: "600",
            }}
          >
            This is {APP_ENV} Environment
          </marquee>
        )}
      </Box>
    </AppBar>
  );
};

export default TopBar;
